import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=50f6fd84&scoped=true&"
import script from "./tab2.vue?vue&type=script&lang=js&"
export * from "./tab2.vue?vue&type=script&lang=js&"
import style0 from "./tab2.vue?vue&type=style&index=0&id=50f6fd84&scoped=true&lang=stylus&"
import style1 from "./tab2.vue?vue&type=style&index=1&id=50f6fd84&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6fd84",
  null
  
)

export default component.exports